import { ICON__copy_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { REMOTE__generation_create } from '@/state/generation/entity/REMOTE__generation_create';
import { set_current_generation } from '@/utils/utils_client_workspace_child_entity_viewers';
import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';
import { useMemo } from 'react';

interface PROPS {}

export function G_HEADER__generations_history_button_clone_current({}: PROPS) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { generation_current, generations_map } = use_slice_generation(['generation_current', 'generations_map']);

  /*
   * STATE
   */

  const is_need_clone = useMemo(() => get_is_need_clone(), [generation_current, generations_map]);

  /*
   * EFFECTS
   */

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = DTO_REQUEST__generation_create.CREATE_FOR_CLONE(generation_current);

    /*
     *
     */
    let action_result = await dispatch(REMOTE__generation_create(request));

    if (typeof action_result.payload != 'string') return;

    let generation_id = action_result.payload;

    assert_string_object_id(generation_id);

    await set_current_generation(generation_id);
  }
  /*
   * METHODS
   */

  function get_is_need_clone() {
    if (generation_current.is_stub()) return false;

    if (generation_current.previous_generation_id.is_empty_object_id()) return true;

    if (!generations_map.has(generation_current.previous_generation_id)) return true;

    let generation_previous = generations_map.get_or_assert(generation_current.previous_generation_id);

    let graph_previous = generation_previous.tool.graph;
    let graph_current = generation_current.tool.graph;

    let out = !graph_previous.is_equal(graph_current);

    return out;
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <></>;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="full-6"
      {...{ onClick }}
      className=""
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={ICON__copy_regular}
    />
  );
}
